export default __webpack_public_path__ + "static/media/loginbg.7faf47e5.jpg";